import { IS_DEV_MODE } from "./config";

const debug_zones = {
    critical: true,
    WebSocketProvider: true,
    TradingView: true,
    useSocketData: true,
    LiteTradeChart: true,
    Asset: true,
    redux: true,
    saga: true,
} as const;

(window as any).jetvix_debug = (zone?: string, value?: any) => {
    if (zone === undefined) {
        console.log('Available debug zones:', Object.entries(debug_zones))
    }
    debug_zones[zone] = value === undefined ? !debug_zones[zone] : value;
}

export const debugLog = IS_DEV_MODE
    ? (zone: keyof typeof debug_zones, ...args) =>
    ((debug_zones[zone])
        ? console.log(...args)
        : null)
    : () => { };

/* use:
    const log =  makeTickLog();
    log(.. here like console.log params );
    ......
    log(.. here like console.log params ); <-- here it will show ms between the first call
                                                with green if less 250 ms yellow if less 1000 mc  and red for anything else 

*/
export const makeTickLog = () => {
    let start = (new Date()).valueOf();
    const log = (...args) => {
        const current = (new Date()).valueOf();
        const diff = current - start;
        console.log(`%c[${diff}]`, `color: ${diff < 250 ? 'green' : (diff < 1000 ? 'yellow' : 'red')} `, ...args);
        start = current;
    }
    return log;
}